import React from 'react';
import ProductReviewsCard from './ProductReviewsCard';
import '../Styles/ProductReviews.css';

const ProductReviews = ({productReviews}) => {
  return (
    <div className='productReview'>
        {productReviews.map((item,index)=> <ProductReviewsCard image={item.image} price={item.price} name={item.name} index={index} key={item.image} review={item.review}/>
             )}
    </div>
  )
}

export default ProductReviews